import { buildUrl } from "../../../helpers/apiHelper";
import axios from "../../../lib/axios"

const getQuoteStatuses = async (
    config,
    options = {
        with: [],
        where: {}
    }
) => {
    const baseUrl = '/api/quote-statuses';

    return await axios
        .get(buildUrl(baseUrl, options), config)
        .then(({ data }) => data?.data ?? [])
        .catch(({ response }) => {
            console.error(response)
            return []
        })
}

const quoteStatusAPI = {
    getQuoteStatuses
}

export default quoteStatusAPI
